import { AppService } from './AppService';

export class WebappService{
    appService = new AppService();
    constructor(){
       
    }


    getInfosApp(uuid) {
      const url = this.appService.getApiUrl()+'app/webapp.php';
      const params = {
        action: "getInfosApp",
        uuid: uuid
      };
      return this.appService.get(url,{params})
        .then(function (response) {
            
            return response.data

        })
        .catch(function (error) {
            
            throw new Error(error);
            
        });
    }


}